import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserService } from '../shared/services/index';
import { CommonService } from '../shared/services/index';
import { GroupService } from "../shared/services/group/group.service";
import { MatDialogRef } from "@angular/material";

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileComponent implements OnInit {
  @ViewChild('profileImage') profileImage;
  profileSelectTab: number = 1;
  name: string = "";
  image: string = "";
  isGeoSite: boolean = false;
  constructor(private activatedRoute: ActivatedRoute, private userService: UserService, private commonService: CommonService, private groupService: GroupService) {
    this.setData();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params.tab == 'users') {
        this.profileSelectTab = 2;
      } else if (params.tab == 'sites') {
        this.profileSelectTab = 3;
      } else if (params.tab == 'devices') {
        this.profileSelectTab = 4;
      }
    });
  }

  ngOnInit() {
    this.userService.userDetailsUpdated().subscribe(() => {
      this.setData();
    });

    this.commonService.getAction().subscribe(r => {
      if (r.action == "shiftTab") {
        if (r.data.tab == "devices") {
          this.profileSelectTab = 4;
        }
      }
    })

  }

  setData() {
    let userDetails = this.userService.getLoggedInUser();
    let userExportPer = userDetails.settings;
    this.isGeoSite = userExportPer.geoData == "1" && userExportPer.geoSites.indexOf("1") !== -1 ? true : false;
    this.name = userDetails["name"] ? userDetails["name"] : "";
    this.image = userDetails["profileImage"] ? "https://xpandretail-assets.s3.amazonaws.com/" + userDetails["profileImage"] + "?v=" + (new Date().getTime()) : "assets/img/profile-pic.png";
  }

  tabChanged(e) {
    this.profileSelectTab = e.index;
    if (e.tab.textLabel == "GeoSites")
      this.groupService.sendAction("reSizeMap", "");
  }

  changeProfilePhoto(files: FileList) {
    if (files.length == 0) {
      return false;
    }
    let file: File = files[0];
    var formData = new FormData();
    formData.append("avatar", file);

    this.userService.changeProfilePhoto(formData).subscribe(r => {
      let userDetails = this.userService.getLoggedInUser();
      this.userService.savePersonalDetailsToToken({
        profileImage: 'profile/' + userDetails["_id"] + ".jpg"
      });
    });
  }

}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/profile/profile.component.ts